import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { listMutations } from './types';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
	},
	filter: {
		ProvozovnaId: null as number | null,
		PracovnikId: null as number | null,
		PracovnikIdText: null as string | null,
		PracovnikOsobniCis: null as string | null,
		DatumOd: null as string | null,
		DatumDo: null as string | null,
		Prirazene: null as boolean | null,
		KaroserieNr: null as string | null,
		VozidloVin: null as string | null,
		VozidloId: null as number | null,
		VozidloSpz: null as string | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {
		[listMutations.VOZIDLO_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.VozidloId = data.value;
			state.filter.VozidloSpz = data.spz;
			state.filter.KaroserieNr = data.karoserieNr;
		},
		[listMutations.PRACOVNIK_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.PracovnikId = data.value;
			state.filter.PracovnikIdText = data.isClear ? null : `${data.text} ${data.jmeno}`;
			state.filter.PracovnikOsobniCis = data.osobniCis;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
